import { Link } from '@/navigation'
import { ArrowStrightRight, Leaf } from '@/components/icons'
import { IServicesData } from '@/types'

import type { FC } from 'react'

const ServicesCard: FC<IServicesData> = ({ slug, name }) => {
  return (
    <Link href={'/services/' + slug} aria-label={name}>
      <div className="flex w-full flex-row items-center justify-between rounded-[12px] border border-secondary-light bg-white px-[20px] py-[16px] outline-none duration-200 hover:border-primary focus:border-secondary">
        <div className="flex flex-row items-center gap-3">
          <Leaf />
          <span className="font-medium">{name}</span>
        </div>
        <ArrowStrightRight />
      </div>
    </Link>
  )
}

export default ServicesCard
